import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import StorePage from "./pages/StorePage";
import AdminCsvUpload from "./pages/AdminCsvUpload";
import Coupon from "./pages/Coupons";
import Categories from "./pages/Categories";
import OurProducts from "./booking_pages/OurProducts";
import ProductDetail from "./booking_pages/ProductDetail";
import CartPage from "./booking_pages/CartPage";
import CheckoutPage from "./booking_pages/CheckoutPage";

import AllProducts from "./booking_pages/DashBoard/Allproducts";
import CategoryStores from "./pages/CategoryStores";

function App() {
  const isLoggedIn = !!localStorage.getItem("access_token");

  return (
    <Router>
      <Routes>

        {/* 🏠 Default */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/all-products" element={<AllProducts />} />

        {/* 🏬 Store Page */}
        <Route path="/stores/:slug" element={<StorePage />} />

        {/* 📚 Public Pages */}
        <Route path="/categories" element={<Categories />} />

        {/* 👉 Category specific page */}
        <Route path="/categories/:categoryName" element={<CategoryStores />} />

        <Route path="/coupons" element={<Coupon />} />

        {/* 🔐 Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* 🧾 Admin */}
        <Route
          path="/admin/upload-csv"
          element={isLoggedIn ? <AdminCsvUpload /> : <Navigate to="/login" replace />}
        />

        {/* 🛍️ Products */}
        <Route path="/products" element={<OurProducts />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />

        {/* 🚦 Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
}

export default App;
